module.exports = __webpack_public_path__ + "static/media/logo-shield.540b1035.svg";